import { useMemo } from "react";
import { useListMaintenanceRequestsQuery } from "../../masters/vehicles/vehiclesApi";
import { useListLposQuery } from "../stockApi";

// Shared "approved maintenance request waiting for an LPO" filter - a
// request counts as pending if it has spare items and no LPO already
// exists referencing it in a non-REJECTED/non-CANCELLED status (so a
// request whose earlier LPO attempt was rejected/cancelled can be
// converted again). Originally inline in PendingVehicleRequests.jsx, now
// shared so LpoForm.jsx's own inline picker offers the exact same set,
// per direct instruction ("same approved maintenance request").
//
// `branchId` (2026-10-02): the Pending Vehicle Requests page passes the header
// branch, LpoForm the form's branch; null/undefined = every branch the caller has.
export const usePendingVehicleRequests = (skip = false, branchId = null) => {
  const { data: requestsPage, isLoading: isLoadingRequests } = useListMaintenanceRequestsQuery(
    { status: "APPROVED", pageSize: 200, branchId: branchId || undefined },
    { skip }
  );
  const { data: lpoPage, isLoading: isLoadingLpos } = useListLposQuery(
    { purposeType: "VEHICLE_MAINTENANCE", pageSize: 200, branchId: branchId || undefined },
    { skip }
  );

  const activelyLinkedRequestGuids = useMemo(() => {
    const set = new Set();
    (lpoPage?.items || []).forEach((lpo) => {
      if (lpo.vehicleRequestRecordGuid && lpo.status !== "REJECTED" && lpo.status !== "CANCELLED") {
        set.add(lpo.vehicleRequestRecordGuid);
      }
    });
    return set;
  }, [lpoPage]);

  const pendingRequests = useMemo(
    () => (requestsPage?.items || []).filter((r) => !activelyLinkedRequestGuids.has(r.recordGuid) && r.spareItemCount > 0),
    [requestsPage, activelyLinkedRequestGuids]
  );

  return { pendingRequests, isLoading: skip ? false : isLoadingRequests || isLoadingLpos };
};
